import { createMachine } from 'xstate';

export const danceMachine = createMachine({
  id: 'dance',
  initial: 'da-Bboy Hip Hop Move',
  states: {
    "da-Bboy Hip Hop Move": { on: { "NEXT01": "da-Belly Dance" }},
    "da-Belly Dance": { on: { "NEXT01": "da-Bellydancing" }},
    "da-Bellydancing": { on: { "NEXT01": "da-Breakdance Freeze Var 2" }},
    "da-Breakdance Freeze Var 2": { on: { "NEXT01": "da-Breakdance Uprock Var 1" }},
    "da-Breakdance Uprock Var 1": { on: { "NEXT01": "da-Breakdance Uprock Var 2" }},
    "da-Breakdance Uprock Var 2": { on: { "NEXT01": "da-Chicken Dance" }},
    "da-Chicken Dance": { on: { "NEXT01": "da-Dancing Twerk" }},
    "da-Dancing Twerk": { on: { "NEXT01": "da-Excited" }},
    "da-Excited": { on: { "NEXT01": "da-Gangnam Style" }},
    "da-Gangnam Style": { on: { "NEXT01": "da-Hip Hop Dancing" }},
    "da-Hip Hop Dancing": { on: { "NEXT01": "da-Hip Hop Dancing 2" }},
    "da-Hip Hop Dancing 2": { on: { "NEXT01": "da-Hip Hop Dancing 3" }},
    "da-Hip Hop Dancing 3": { on: { "NEXT01": "da-Hip Hop Dancing copie" }},
    "da-Hip Hop Dancing copie": { on: { "NEXT01": "da-Hip Hop Dancing copie 2" }},
    "da-Hip Hop Dancing copie 2": { on: { "NEXT01": "da-House Dancing" }},
    "da-House Dancing": { on: { "NEXT01": "da-Jazz Dancing" }},
    "da-Jazz Dancing": { on: { "NEXT01": "da-Jazz Dancing 2" }},
    "da-Jazz Dancing 2": { on: { "NEXT01": "da-Joyful Jump" }},
    "da-Joyful Jump": { on: { "NEXT01": "da-Northern Soul Spin" }},
    "da-Northern Soul Spin": { on: { "NEXT01": "da-Northern Soul Spin Combo" }},
    "da-Northern Soul Spin Combo": { on: { "NEXT01": "da-Robot Hip Hop Dance" }},
    "da-Robot Hip Hop Dance": { on: { "NEXT01": "da-Rumba Dancing" }},
    "da-Rumba Dancing": { on: { "NEXT01": "da-Salsa Dancing" }},
    "da-Salsa Dancing": { on: { "NEXT01": "da-Salsa Dancing 2" }},
    "da-Salsa Dancing 2": { on: { "NEXT01": "da-Salsa Dancing 4" }},
    "da-Salsa Dancing 4": { on: { "NEXT01": "da-Samba Dancing" }},
    "da-Samba Dancing": { on: { "NEXT01": "da-Samba Dancing 2" }},
    "da-Samba Dancing 2": { on: { "NEXT01": "da-Silly Dancing" }},
    "da-Silly Dancing": { on: { "NEXT01": "da-Swing Dancing" }},
    "da-Swing Dancing": { on: { "NEXT01": "da-Swing Dancing 2" }},
    "da-Swing Dancing 2": { on: { "NEXT01": "da-Tut Hip Hop Dance" }},
    "da-Tut Hip Hop Dance": { on: { "NEXT01": "da-Twist Dance" }},
    "da-Twist Dance": { on: { "NEXT01": "da-Wave Hip Hop Dance" }},
    "da-Wave Hip Hop Dance": { on: { "NEXT01": "da-Bboy Hip Hop Move" }},
  }
});